import styled from 'styled-components';

const ModalContent = styled.div ``;
const Header = styled.div `
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  max-width: ${(props) => props.width}px;
`;
const Title = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  font-weight: ${(props) => props.theme.font.weightExtrabold};
`;
const SelectorsWrapper = styled.div ``;
const CalendarsWrapper = styled.div `
  height: 50vh;
  overflow: auto;
`;

export { CalendarsWrapper, Header, ModalContent, SelectorsWrapper, Title };
